import { IModuleUserProgressQuery } from '../interfaces/module-user-progress.query.interface';
import { ModuleUserNextSection } from './module-user-next-section.model';

export class ModuleUserProgress {
    id: string;
    status: string;
    completedSectionsCount: number;
    nextSection: ModuleUserNextSection;
    sectionCompleteness: string;
    coursesBooked: number;
    coursesCompleted: number;
    programProgress: number;
    completed: number;
    total: number;
    progress: number;

    constructor(moduleUserProgress?: IModuleUserProgressQuery) {
        if (moduleUserProgress) {
            this.id = moduleUserProgress.id ? moduleUserProgress.id.toString() : null;
            this.status = moduleUserProgress.status;
            this.completedSectionsCount = moduleUserProgress.completed_sections_count;
            this.nextSection = moduleUserProgress.next_section ? new ModuleUserNextSection(moduleUserProgress.next_section) : null;
            this.sectionCompleteness = moduleUserProgress.section_completeness;
            this.coursesBooked = moduleUserProgress.courses_booked;
            this.coursesCompleted = moduleUserProgress.courses_completed;
            this.programProgress = moduleUserProgress.program_progress;
            this.completed = moduleUserProgress.completed;
            this.total = moduleUserProgress.total;
            this.progress = moduleUserProgress.progress;
        } else {
            this.id = null;
            this.status = null;
            this.completedSectionsCount = null;
            this.nextSection = null;
            this.sectionCompleteness = null;
            this.coursesBooked = null;
            this.coursesCompleted = null;
            this.programProgress = null;
            this.completed = null;
            this.total = null;
            this.progress = null;
        }
    }
}
